import Swal from "sweetalert2";
import copy from "copy-to-clipboard";

/**
export function popLink(link) {
    Swal.fire({
        icon: 'warning',
        title: 'Para editar su postulación, volver al siguiente link:',
        html: "<p>"+link+"</p><p>Se le sugiere que lo guarde</p>",
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Copiar el link.'
    }).then((result) => {
          if (result.value) {
            postulacionSuccess(link)
          }
        })
}
*/

export function postulacionSuccess(correo_postulación){
    Swal.fire({
        title: 'Postulación Finalizada',
        html: 'Su postulación se ha completado exitosamente. Hemos enviado un email de confirmación a ' + correo_postulación,
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Volver al inicio',
        onClose(popup: HTMLElement) {
            redirectToHome()
        }
    }).then(() => redirectToHome())
}

export function editPostulacionSuccess(correo_postulación){
    Swal.fire({
        title: 'Postulación Editada',
        html: 'Su postulación se ha editado exitosamente. Hemos enviado un email de confirmación a ' + correo_postulación,
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Volver al inicio',
        onClose(popup: HTMLElement) {
            redirectToHome()
        }
    }).then(() => redirectToHome())
}

function redirectToHome() {
    window.location.href = "/ListaConcursos/"
}

